import { customElement } from "lit/decorators.js";
import { Subheading } from "@/components/subheading";

@customElement("eko-page-header-title")
class PageHeaderTitle extends Subheading {
  constructor() {
    super();

    this.size = "lg";
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-page-header-title": PageHeaderTitle;
  }
}

export default PageHeaderTitle;
